import React, { useState, useEffect } from 'react'
import { Field, Formik, Form } from 'formik'
import Container from './styles'
import {
  Button,
  TextInput
} from '@valid/components'

export default function ({ state, className, value, label, mask = null, applyFilter, handleSubmit, loading, validationSchema }) {
  const [formValues, setFormValues] = useState({})
  const [formErrors, setFormErrors] = useState({})
  const [initialData, setInitialData] = useState({})

  useEffect(() => {
    let data = {}
    data[label] = value

    setInitialData(data)
  }, [state, value, label])

  const handleInternalSubmit = () => {

    handleSubmit(formValues, formErrors)

  }
  return (
    <Container className={className}>
      <div className="value">
        {<h3> {applyFilter ? applyFilter(value) : value} </h3>}
      </div>
    </Container >
  )
}
